import { Chip } from '@winnin/winnin_ui.components.chip'

import ChipsDropdown from 'components/ChipsDropdown'

import type { ITypeFilterView } from './type-filter.types'

import './type-filter.styles.scss'

export const TypeFilterView = ({
  handleChange,
  isTerritoryTypeSelected,
  territoryTypes,
  territoryTypesValue,
}: ITypeFilterView) => {
  return (
    <div className="TerritoryTypeFilter-wrapper">
      {isTerritoryTypeSelected ? (
        <ChipsDropdown
          label={territoryTypesValue?.label}
          onChange={handleChange}
          options={territoryTypes}
          selected={territoryTypesValue}
          alignment="left"
        />
      ) : (
        <div className="territoryTypes-chips">
          {territoryTypes.map(item => {
            if (!item?.value) {
              return null
            }
            return <Chip title={item.label} key={item.value} handleClick={() => handleChange(item)} />
          })}
        </div>
      )}
    </div>
  )
}
